// src/services/printer/commands.js
export const ESCPOSCommands = {
  INIT: [0x1b, 0x40],
  CENTER: [0x1b, 0x61, 0x01],
  LEFT: [0x1b, 0x61, 0x00],
  BOLD_ON: [0x1b, 0x45, 0x01],
  BOLD_OFF: [0x1b, 0x45, 0x00],
  CUT: [0x1d, 0x56, 0x41, 0x00],
};
